<template>
	<app-title-bar
		:icon="['fas', 'fa-truck']"
		subtitle="Yard"
		title="Journey Detail"
		:badges="[
			journey?.link_number,
			journey?.journey_number,
			journey?.account_name,
			journeyTypeBadge,
			vehicleInfoBadge
		]">
		<div class="flex gap-3">
			<resource-details :loading="loading || !journey" :resource="journey" />

			<app-button to="/yard" icon="fa-circle-left"> Back </app-button>
		</div>
	</app-title-bar>

	<div class="flex flex-col-reverse 2xl:flex-row gap-4">
		<app-panel class="grow" title="Journey Items">
			<JourneyItemsTable :loading="loading" :items="items" />
		</app-panel>
	</div>
</template>

<script lang="ts" setup>
	import { ref, onMounted, computed } from 'vue'
	import { useRoute } from 'vue-router'
	import useToasterStore from '@/stores/toaster'
	import type { Journey } from '@/data/schema/journey'
	import type { JourneyItem } from '@/data/schema/journey-item'
	import JourneyService from '@/services/journey'
	import ResourceDetails from '@/components/partials/panels/ResourceDetails.vue'
	import JourneyItemsTable from '@/components/datatables/yard/journey/JourneyItemsTable.vue'

	// Resources
	const api = new JourneyService()
	const route = useRoute()
	const toaster = useToasterStore()

	// Data
	const loading = ref(true)
	const journeyNumber = ref()
	const journey = ref<Journey>()
	const items = ref<JourneyItem[]>([])

	const journeyTypeBadge = computed(() => {
		return journey.value ? journey.value.type_name : ''
	})

	const vehicleInfoBadge = computed(() => {
		return journey.value
			? `${journey.value.vehicle_display_name} - ${journey.value.vehicle_name}`
			: ''
	})

	/**
	 * Get contract and contract item data
	 */
	async function getData() {
		loading.value = true

		api.get(journeyNumber.value, { withItems: true })
			.then((res) => {
				journey.value = res.data.data
				items.value = journey.value!.items
				loading.value = false
			})
			.catch((error) => {
				console.error(error)
				toaster.error({ text: 'Error occurred returning journey items' })
			})
	}

	onMounted(() => {
		journeyNumber.value = route.params.id

		if (journeyNumber.value) {
			getData()
		}
	})
</script>
